module.exports = __webpack_public_path__ + "static/media/I.b72236af.png";